module.exports = __webpack_public_path__ + "static/media/marketing-feature-3.d93f2c1e.svg";